/**
 * @file index.tsx
 *
 * @fileoverview Renders Item Item for the dropdown select.
 */
import React from "react";
import styles from "./item.module.scss";

interface ItemProps {
  /**
   * Contents inside the Item element.
   */
  children: React.ReactNode;
  /**
   * If the element is currently active.
   */
  isActive: boolean;
  /**
   * If the element is currently opened.
   */
  isOpen: boolean;
}
export default function Item({
  children,
  isActive,
  isOpen,
  ...props
}: ItemProps) {
  return (
    <div
      className={styles.item}
      style={{
        ...(isActive
          ? {
              background: `var(--select-item-background-hover)`,
            }
          : null),
        ...(isOpen
          ? {
              fontWeight: 700,
            }
          : null),
      }}
      {...props}
    >
      {children}
    </div>
  );
}
export { Item };
